import Vue from 'vue'
import VueRouter from 'vue-router'
import store from '@/store'


import { getToken } from '@/utils/auth'

Vue.use(VueRouter)

// 路由配置
const routes = [
  {
    path: '/',
    name: 'Login',
    component: () => import('@/views/Login.vue'),
    meta: {
      title: '登录',
      noNeedAuth: true // 不需要登录
    }
  },
  {
    path: '/index',
    name: 'Home',
    component: () => import('@/views/Home.vue'),
    meta: {
      title: '首页'
    }
  },
  {
    path: '/exam',
    name: 'Exam',
    component: () => import('@/views/Exam.vue'),
    meta: {
      title: '考试'
    }
  },
  {
    path: '/examProctoring',
    name: 'ExamProctoring',
    component: () => import('@/views/ExamProctoring.vue'),
    meta: {
      title: '考试监考'
    }
  },
  {
    path: '/401',
    name: '401',
    component: () => import('@/views/401.vue'),
    meta: {
      title: '401',
      noNeedAuth: true // 不需要登录
    }
  },
  {
    path: '*',
    redirect: '/index'
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  // 1. 设置页面标题（保持原有逻辑）
  document.title = to.meta.title || "考试系统";

  // 2. 区分「无需登录页面」和「需登录页面」
  const isNeedAuth = !to.meta.noNeedAuth; // 需登录：true，无需登录：false
  const token = getToken(); // 假设 getToken() 是获取本地存储中 token 的方法

  if (isNeedAuth) {
    // 👉 场景1：访问需登录的页面（如 /index）
    if (token) {
      // 2.1 已登录：检查是否有用户信息，避免重复请求

      // const userInfo = store.getters.userInfo; // 需在 Vuex 的 getters 中定义 userInfo
      const userInfo = store.state.user.userInfo 

      console.log(store,'store',userInfo)

      if (userInfo.id) {
        // 2.1.1 已有用户信息：直接进入目标页面（如 /index）
        next();
      } else {
        // 2.1.2 无用户信息：调用接口获取，错误只在控制台打印
        store.dispatch("user/getInfo", localStorage.getItem("EXAM_CODE") ? localStorage.getItem("EXAM_CODE") : "")
          .then(() => {
            // 获取成功：进入目标页面
            next();
          })
          .catch((err) => {
            // ❌ 错误处理：只打印控制台，不弹页面提示
            console.error("路由守卫：获取用户信息失败", err);
            // 错误后登出 + 跳回登录页（带 EXAM_CODE 参数）
            store.dispatch("user/logout")
              .then(() => {
                const examCode = localStorage.getItem("EXAM_CODE") || "";
                next(`/?p=${examCode}`); // 跳回登录页 /，携带参数
              });
          });
      }
    } else {
      // 2.2 未登录：跳回登录页（禁止访问需登录页面）
      const examCode = localStorage.getItem("EXAM_CODE") || "";
      next(`/?p=${examCode}`);
    }
  } else {
    // 👉 场景2：访问无需登录的页面（如登录页 /）
    if (token && to.path === "/") {
      // 2.3 已登录却访问登录页：自动跳转到首页 /index
      next({ path: "/index" });
    } else {
      // 2.4 未登录访问无需登录页面：直接进入
      next();
    }
  }
});

export default router
